// @flow
import React from 'react';
import PasswordForm from '../PasswordForm/PasswordForm';
import background from '../../assets/bg.jpg';
import logo from '../../assets/logo.png';
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator';
import './Activation.css';

export type Props = {
  user: ?any,
  onActivation: Function,
  error: ?any,
  isLoading: boolean,
};

const Activation = ({user, onActivation, isLoading, error}: Props) => (
  <div className="Activation">
    <LoadingIndicator isLoading={isLoading} />
    <div
      className="Activation-background"
      style={({
        backgroundImage: `url('${background}')`,
      })}></div>
    {user && !error &&
      <div>
        <div className="row">
          <div className="column">
            <img
              src={logo}
              className="Activation-logo"
              alt="logo" />
            <h1>dina tillval</h1>
            <p className="Activation-info">
              Välj ett lösenord för ditt användarkonto
            </p>
          </div>
        </div>
        <div className="row align-center">
          <div className="Form column box">
            <div className="row">
              <div className="column">
                <label>Användarnamn</label>
                <p>{user.username}</p>
              </div>
            </div>
            <div className="row align-center">
              <div className="column">
                <PasswordForm onSubmit={onActivation} />
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    {!!error &&
      <div className="row align-center">
        <div className="column small-12 medium-10 large-7">
          <div className="callout warning">
            Ett fel har inträffat, vänligen försök igen.
            Har du forsatt problem så kontakta oss!
          </div>
        </div>
      </div>
    }
  </div>
);

export default Activation;



// WEBPACK FOOTER //
// ./src/components/Activation/Activation.js